import { Message, MessageBox } from 'element-ui'

export function successMsg (message = '', duration = 3000) {
  Message({
    message,
    duration,
    center: true,
    type: 'success',
    dangerouslyUseHTMLString: true
  })
}

export function errorMsg (message = '', duration = 5000) {
  Message({
    message,
    duration,
    center: true,
    type: 'error',
    dangerouslyUseHTMLString: true
  })
}

export function confirm (message = '', options = {}) {
  return MessageBox.confirm(message, {
    confirmButtonText: '確定',
    cancelButtonText: '返回',
    confirmButtonClass: 'el-button--info',
    cancelButtonClass: 'el-button--info secondary-black-btn',
    center: true,
    showClose: false,
    ...options
  })
}

export function install (Vue) {
  Vue.prototype.$successMsg = successMsg
  Vue.prototype.$errorMsg = errorMsg
  Vue.prototype.$confirm = confirm
}

export default {
  successMsg,
  errorMsg,
  confirm,
  install
}
